module.exports = __webpack_public_path__ + "static/Nanopesos3-405f95587c034a2e147366b87bfb0330.png";